import { GoogleOutlined } from '@ant-design/icons'
import { ProviderHelperClient } from '~/plugins/data-connector/helpers/provider.helper.client'
import { ProviderAuthenticationClient } from '../../../authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderGmailCommon } from '../common'

const authentication = ProviderAuthenticationClient.Oauth2({
  ...ProviderGmailCommon.authentication,
  clientId: ProviderHelperClient.getEnvVariable('google', 'CLIENT_ID'),
})

export const ProviderGmailClient: ProviderClient = {
  key: ProviderGmailCommon.key,
  authentication,
  description: {
    label: 'Gmail',
    icon: <GoogleOutlined />,
    triggers: [
      {
        key: 'NewEmail',
        label: 'New email',
        output: [
          {
            key: 'providerAccountId',
          },
          {
            key: 'message.id',
          },
          {
            key: 'to',
          },
          {
            key: 'snippet',
          },
          {
            key: 'content',
          },
        ],
      },
    ],
    actions: [
      {
        key: 'createDraft',
        label: 'Create draft',
        input: [
          {
            key: 'email',
          },
          {
            key: 'subject',
          },
          {
            key: 'content',
          },
        ],
        output: [
          {
            key: 'id',
          },
        ],
      },
      {
        key: 'findManyEmails',
        label: 'List emails',
        input: [
          {
            key: 'labelIds',
            type: 'array',
          },
          {
            key: 'dateAfter',
          },
        ],
        output: [
          { key: 'id' },
          { key: 'to' },
          { key: 'from' },
          { key: 'snippet' },
          { key: 'timestamp' },
          { key: 'content' },
        ],
      },
      {
        key: 'findOneEmail',
        label: 'Read an email',
        input: [
          {
            key: 'emailId',
          },
        ],
        output: [
          { key: 'id' },
          { key: 'to' },
          { key: 'from' },
          { key: 'snippet' },
          { key: 'timestamp' },
          { key: 'content' },
        ],
      },
      {
        key: 'sendEmail',
        label: 'Send email',
        input: [
          {
            key: 'email',
          },
          {
            key: 'subject',
          },
          {
            key: 'content',
          },
        ],
        output: [
          {
            key: 'id',
          },
        ],
      },
      {
        key: 'labelManyEmails',
        label: 'Label many emails',
        input: [],
        output: [],
      },
    ],
  },
}
